import React, { createContext, useState } from "react";

export const MapContext = createContext();

const MapContextProvider = ({ children }) => {
	const [hoveredId, setHoveredId] = useState("");
	const [popUpID, setPopId] = useState("");
	const [contextGallary, setContextGalaary] = useState(false);
	return (
		<MapContext.Provider
			value={{
				hoveredId,
				setHoveredId,
				popUpID,
				setPopId,
				contextGallary,
				setContextGalaary,
			}}
		>
			{children}
		</MapContext.Provider>
	);
};

export default MapContextProvider;
